import { useState, useEffect } from 'react';
import { DataModelsList } from '../components/datamodels';
import { DataModelWizard } from '../components/datamodels/DataModelWizard';

export default function DataModelsPage() {
    const [view, setView] = useState<'list' | 'wizard'>('list');
    const [selectedDataModelId, setSelectedDataModelId] = useState<string | null>(null);

    useEffect(() => {
        const handleReset = (e: any) => {
            if (e.detail?.pageId === 'datamodels') {
                setView('list');
                setSelectedDataModelId(null);
            }
        };
        window.addEventListener('reset-page-state', handleReset);
        return () => window.removeEventListener('reset-page-state', handleReset);
    }, []);

    // If view is wizard, render the wizard
    if (view === 'wizard') {
        return (
            <div className="h-full w-full">
                <DataModelWizard
                    isOpen={true}
                    dataModelId={selectedDataModelId}
                    onClose={() => {
                        setView('list');
                        setSelectedDataModelId(null);
                    }}
                    onSuccess={() => {
                        setView('list');
                        setSelectedDataModelId(null);
                    }}
                />
            </div>
        );
    }

    return (
        <DataModelsList
            onEdit={(id: string) => {
                setSelectedDataModelId(id);
                setView('wizard');
            }}
            onCreate={() => {
                setSelectedDataModelId(null);
                setView('wizard');
            }}
        />
    );
}
